import React from 'react'
import { CharterOfferHeader } from '../HomeComponents/CharterOfferHeader';
import { CharterOfferMainSection } from '../HomeComponents/CharterOfferMainSection';

export const CharterOfferSection = () => {
  return (
    <section className="OfferSection">
      <CharterOfferHeader/>
      <CharterOfferMainSection/>
    </section>
  )
}
